module.exports = __webpack_public_path__ + "media/images/faces/male/33-a13601f8a58562440446ced44ed5e4cf.jpg";